import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dPromotions$dTypes$dPromotionalItem from "../Restaumatic.Promotions.Types.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
const $PromotionalItemAssignment = (tag, _1) => ({tag, _1});
const $PromotionalItemSource = (tag, _1) => ({tag, _1});
const $PromotionalItemTarget = (tag, _1) => ({tag, _1});
const $SelectionStatus = (tag, _1) => ({tag, _1});
const TargetCart = /* #__PURE__ */ $PromotionalItemTarget("TargetCart");
const TargetProductItems = value0 => $PromotionalItemTarget("TargetProductItems", value0);
const NoSource = /* #__PURE__ */ $PromotionalItemSource("NoSource");
const SourceProductItems = value0 => $PromotionalItemSource("SourceProductItems", value0);
const AssignmentToCart = /* #__PURE__ */ $PromotionalItemAssignment("AssignmentToCart");
const UnassignmentToCart = /* #__PURE__ */ $PromotionalItemAssignment("UnassignmentToCart");
const AssignmentToProduct = value0 => $PromotionalItemAssignment("AssignmentToProduct", value0);
const UnassignmentToProduct = /* #__PURE__ */ $PromotionalItemAssignment("UnassignmentToProduct");
const AutoEnabled = /* #__PURE__ */ $SelectionStatus("AutoEnabled");
const AutoDisabled = /* #__PURE__ */ $SelectionStatus("AutoDisabled");
const UserEnabled = value0 => $SelectionStatus("UserEnabled", value0);
const UserDisabled = /* #__PURE__ */ $SelectionStatus("UserDisabled");
const PromotionalItem = x => x;
const selectionStatusAge = v => {
  if (v.tag === "UserEnabled") { return Data$dMaybe.$Maybe("Just", v._1); }
  return Data$dMaybe.Nothing;
};
const productItemKeysInTarget = v => {
  if (v.tag === "TargetCart") { return Data$dMap$dInternal.Leaf; }
  if (v.tag === "TargetProductItems") { return v._1; }
  $runtime.fail();
};
const oldenUserEnabledSelectionStatus = v => {
  if (v.tag === "UserEnabled") { return $SelectionStatus("UserEnabled", v._1 + 1 | 0); }
  return v;
};
const newtypePromotionalItem = {Coercible0: () => {}};
const promotion = x => x.promotion;
const promotionId = x => x.promotion.promotionId;
const promotions = /* #__PURE__ */ Data$dFunctor.arrayMap(promotion);
const promotionalItemId = x => x.promotionalItemId;
const promotionalItemInput = x => x.input;
const selectedFreeby = promoItem => {
  if (promoItem.input.tag === "FreeProductInput") {
    return Restaumatic$dPromotionsEngine$dPromotions$dPromotion.findPromotionFreeby(promoItem.input._1.selection)(promoItem.promotion);
  }
  return Data$dMaybe.Nothing;
};
const promotionalItemValue = x => x.value;
const selection = x => x.selection;
const oldenUserSelection = promoItem => (
  {...promoItem, selection: promoItem.selection.tag === "UserEnabled" ? $SelectionStatus("UserEnabled", promoItem.selection._1 + 1 | 0) : promoItem.selection}
);
const selectionAge = x => {
  if (x.selection.tag === "UserEnabled") { return Data$dMaybe.$Maybe("Just", x.selection._1); }
  return Data$dMaybe.Nothing;
};
const setActive = active => promoItem => ({...promoItem, active});
const setInputFreeby = freeby => promoItem => (
  {...promoItem, input: Restaumatic$dPromotions$dTypes$dPromotionalItem.$PromotionalItemInput("FreeProductInput", {selection: freeby})}
);
const selectFreeby = freeby => promoItem => {
  if (Restaumatic$dPromotionsEngine$dPromotions$dPromotion.isInPromotionFreebies(freeby)(promoItem.promotion)) {
    return {...promoItem, input: Restaumatic$dPromotions$dTypes$dPromotionalItem.$PromotionalItemInput("FreeProductInput", {selection: freeby})};
  }
  return promoItem;
};
const setNoInput = promoItem => ({...promoItem, input: Restaumatic$dPromotions$dTypes$dPromotionalItem.NoInput});
const setSelection = selectionStatus => promoItem => ({...promoItem, selection: selectionStatus});
const setValue = newValue => promoItem => ({...promoItem, value: newValue});
const source = x => x.source;
const sourceProductItems = item => {
  if (item.source.tag === "NoSource") { return []; }
  if (item.source.tag === "SourceProductItems") { return item.source._1; }
  $runtime.fail();
};
const target = x => x.target;
const targetProductItemKeys = x => {
  if (x.target.tag === "TargetCart") { return Data$dMap$dInternal.Leaf; }
  if (x.target.tag === "TargetProductItems") { return x.target._1; }
  $runtime.fail();
};
const targetContains = dictOrd => promoItem => prodKey => {
  const $0 = Data$dMap$dInternal.lookup(Restaumatic$dPromotionsEngine$dCart$dProductItem.ordProductItemKey(dictOrd))(prodKey)((() => {
    if (promoItem.target.tag === "TargetCart") { return Data$dMap$dInternal.Leaf; }
    if (promoItem.target.tag === "TargetProductItems") { return promoItem.target._1; }
    $runtime.fail();
  })());
  if ($0.tag === "Nothing") { return false; }
  if ($0.tag === "Just") { return true; }
  $runtime.fail();
};
const value = x => x.value;
const mkUserEnabled = UserEnabled;
const mkUserEnabledDefault = /* #__PURE__ */ $SelectionStatus("UserEnabled", 0);
const mkUserDisabled = UserDisabled;
const mkUnassignmentToProduct = UnassignmentToProduct;
const mkUnassignmentToCart = UnassignmentToCart;
const mkTargetItems = dictFoldable => dictOrd => {
  const $0 = Restaumatic$dPromotionsEngine$dCart$dProductItem.ordProductItemKey(dictOrd);
  const $1 = dictFoldable.foldl(m => a => Data$dMap$dInternal.insert($0)(a)()(m))(Data$dMap$dInternal.Leaf);
  return x => $PromotionalItemTarget("TargetProductItems", $1(x));
};
const mkTargetCart = TargetCart;
const mkSourceItems = SourceProductItems;
const mkPromotionalItem = promoItemId => promo => initSelection => initInput => initVal => initAssignement => initTarget => initSource => (
  {
    promotionalItemId: promoItemId,
    promotion: promo,
    target: initTarget,
    source: initSource,
    assignment: initAssignement,
    selection: initSelection,
    input: initInput,
    value: initVal,
    active: true
  }
);
const mkNoSource = NoSource;
const mkNoInput = Restaumatic$dPromotions$dTypes$dPromotionalItem.NoInput;
const mkFreeProductInput = freeProductChoice => Restaumatic$dPromotions$dTypes$dPromotionalItem.$PromotionalItemInput("FreeProductInput", {selection: freeProductChoice});
const mkDefaultAssignment = promo => {
  if (promo.conditions.tag === "CartPromotion") { return UnassignmentToCart; }
  if (promo.conditions.tag === "ProductPromotion") { return UnassignmentToProduct; }
  $runtime.fail();
};
const mkAutoEnabled = AutoEnabled;
const mkAutoDisabled = AutoDisabled;
const mkAssignmentToProduct = AssignmentToProduct;
const mkAssignmentToCart = AssignmentToCart;
const isUserSelection = v => v.tag === "UserEnabled" || v.tag === "UserDisabled";
const isUserEnabledSelection = v => v.tag === "UserEnabled";
const isUserDisabledSelection = v => v.tag === "UserDisabled";
const isTouchedByUser = x => x.selection.tag === "UserEnabled" || x.selection.tag === "UserDisabled";
const isProductPromotionalItem = x => {
  if (x.promotion.conditions.tag === "CartPromotion") { return false; }
  if (x.promotion.conditions.tag === "ProductPromotion") { return true; }
  $runtime.fail();
};
const isEnabledSelection = v => v.tag === "UserEnabled" || v.tag === "AutoEnabled";
const isEnabledByUser = x => x.selection.tag === "UserEnabled";
const isEnabled = x => x.selection.tag === "UserEnabled" || x.selection.tag === "AutoEnabled";
const isCartPromotionalItem = x => {
  if (x.promotion.conditions.tag === "CartPromotion") { return true; }
  if (x.promotion.conditions.tag === "ProductPromotion") { return false; }
  $runtime.fail();
};
const isAutoAssignablePromotionalItem = x => x.promotion.autoAssignable;
const isActive = x => x.active;
const input = x => x.input;
const hasRequiredInput = item => true;
const isItemAutoAssigneable = item => item.promotion.autoAssignable;
const genericSelectionStatus = {
  to: x => {
    if (x.tag === "Inl") { return AutoEnabled; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return AutoDisabled; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $SelectionStatus("UserEnabled", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return UserDisabled; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "AutoEnabled") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "AutoDisabled") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "UserEnabled") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "UserDisabled") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))); }
    $runtime.fail();
  }
};
const showSelectionStatus = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "AutoEnabled"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "AutoDisabled"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})({reflectSymbol: () => "UserEnabled"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "UserDisabled"});
    return x => {
      const $4 = genericSelectionStatus.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const genericPromotionalItemTarget = {
  to: x => {
    if (x.tag === "Inl") { return TargetCart; }
    if (x.tag === "Inr") { return $PromotionalItemTarget("TargetProductItems", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "TargetCart") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "TargetProductItems") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showPromotionalItemTarget = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "TargetCart"});
      const $1 = Data$dShow$dGeneric.genericShowConstructor((() => {
        const $1 = Data$dSet.showSet(Restaumatic$dPromotionsEngine$dCart$dProductItem.showProductItemKey(dictShow));
        return {genericShowArgs: v => [$1.show(v)]};
      })())({reflectSymbol: () => "TargetProductItems"});
      return x => {
        if (x.tag === "TargetCart") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
        if (x.tag === "TargetProductItems") { return $1["genericShow'"](x._1); }
        $runtime.fail();
      };
    })()
  }
);
const genericPromotionalItemSource = {
  to: x => {
    if (x.tag === "Inl") { return NoSource; }
    if (x.tag === "Inr") { return $PromotionalItemSource("SourceProductItems", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "NoSource") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "SourceProductItems") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showPromotionalItemSource = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "NoSource"});
      const $1 = Data$dShow$dGeneric.genericShowConstructor((() => {
        const $1 = Data$dShow.showArrayImpl(Restaumatic$dPromotionsEngine$dCart$dProductItem.showProductItemKey(dictShow).show);
        return {genericShowArgs: v => [$1(v)]};
      })())({reflectSymbol: () => "SourceProductItems"});
      return x => {
        if (x.tag === "NoSource") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
        if (x.tag === "SourceProductItems") { return $1["genericShow'"](x._1); }
        $runtime.fail();
      };
    })()
  }
);
const genericPromotionalItemAssignment = {
  to: x => {
    if (x.tag === "Inl") { return AssignmentToCart; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return UnassignmentToCart; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $PromotionalItemAssignment("AssignmentToProduct", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return UnassignmentToProduct; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "AssignmentToCart") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "UnassignmentToCart") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "AssignmentToProduct") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "UnassignmentToProduct") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)));
    }
    $runtime.fail();
  }
};
const showPromotionalItemAssignment = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "AssignmentToCart"});
      const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "UnassignmentToCart"});
      const $2 = Data$dShow$dGeneric.genericShowConstructor((() => {
        const $2 = Restaumatic$dPromotionsEngine$dCart$dProductItem.showProductItemKey(dictShow);
        return {genericShowArgs: v => [$2.show(v)]};
      })())({reflectSymbol: () => "AssignmentToProduct"});
      const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "UnassignmentToProduct"});
      return x => {
        const $4 = genericPromotionalItemAssignment.from(x);
        if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
        if ($4.tag === "Inr") {
          if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
          if ($4._1.tag === "Inr") {
            if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
            if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      };
    })()
  }
);
const showPromotionalItem = dictShow => (
  {
    show: item => "PromotionalItem\n{ promotionalItemId: " + Data$dShow.showIntImpl(item.promotionalItemId) + "\n, promotion:         " + Restaumatic$dPromotionsEngine$dPromotions$dPromotion.showPromotion.show(item.promotion) + "\n, target:            " + showPromotionalItemTarget(dictShow).show(item.target) + "\n, source:            " + showPromotionalItemSource(dictShow).show(item.source) + "\n, assignment:        " + showPromotionalItemAssignment(dictShow).show(item.assignment) + "\n, selection:         " + showSelectionStatus.show(item.selection) + "\n, input:             " + Restaumatic$dPromotions$dTypes$dPromotionalItem.showPromotionalItemInput.show(item.input) + "\n, value:             " + (() => {
      if (item.value.tag === "Just") { return "(Just " + Data$dMoney$dRounded.toString(item.value._1) + ")"; }
      if (item.value.tag === "Nothing") { return "Nothing"; }
      $runtime.fail();
    })() + (item.active ? "\n, active:            true\n}" : "\n, active:            false\n}")
  }
);
const genericPromotionalItem = {to: x => x, from: x => x};
const functorPromotionalItemSource = {
  map: f => m => {
    if (m.tag === "NoSource") { return NoSource; }
    if (m.tag === "SourceProductItems") {
      return $PromotionalItemSource("SourceProductItems", Data$dFunctor.arrayMap(m$1 => ({product: f(m$1.product), productSeq: m$1.productSeq}))(m._1));
    }
    $runtime.fail();
  }
};
const functorPromotionalItemAssignment = {
  map: f => m => {
    if (m.tag === "AssignmentToCart") { return AssignmentToCart; }
    if (m.tag === "UnassignmentToCart") { return UnassignmentToCart; }
    if (m.tag === "AssignmentToProduct") { return $PromotionalItemAssignment("AssignmentToProduct", {product: f(m._1.product), productSeq: m._1.productSeq}); }
    if (m.tag === "UnassignmentToProduct") { return UnassignmentToProduct; }
    $runtime.fail();
  }
};
const forceSetAssignment = assignementStatus => promoItem => ({...promoItem, assignment: assignementStatus});
const setAssignment = dictOrd => ass => promoItem => {
  if (promoItem.promotion.conditions.tag === "CartPromotion") {
    if (ass.tag === "AssignmentToCart") { return {...promoItem, assignment: ass}; }
    if (ass.tag === "UnassignmentToCart") { return {...promoItem, assignment: ass}; }
    if (ass.tag === "AssignmentToProduct") { return promoItem; }
    if (ass.tag === "UnassignmentToProduct") { return promoItem; }
    return promoItem;
  }
  if (promoItem.promotion.conditions.tag === "ProductPromotion") {
    if (ass.tag === "AssignmentToCart") { return promoItem; }
    if (ass.tag === "UnassignmentToCart") { return promoItem; }
    if (ass.tag === "AssignmentToProduct") {
      if (targetContains(dictOrd)(promoItem)(ass._1)) { return {...promoItem, assignment: ass}; }
      return promoItem;
    }
    if (ass.tag === "UnassignmentToProduct") { return {...promoItem, assignment: ass}; }
    return promoItem;
  }
  if (ass.tag === "AssignmentToCart") { $runtime.fail(); }
  if (ass.tag === "UnassignmentToCart") { $runtime.fail(); }
  if (ass.tag === "AssignmentToProduct") { $runtime.fail(); }
  if (ass.tag === "UnassignmentToProduct") { $runtime.fail(); }
  return promoItem;
};
const unassign = dictOrd => promoItem => {
  if (promoItem.promotion.conditions.tag === "CartPromotion") { return setAssignment(dictOrd)(UnassignmentToCart)(promoItem); }
  if (promoItem.promotion.conditions.tag === "ProductPromotion") { return setAssignment(dictOrd)(UnassignmentToProduct)(promoItem); }
  $runtime.fail();
};
const excludeItemsFrom = subset => Data$dArray.filter(item => {
  const $0 = item.promotionalItemId;
  return !Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v => v1 => v || v1})})($1 => $0 === $1)(Data$dFunctor.arrayMap(promotionalItemId)(subset));
});
const eqSelectionStatus = {
  eq: x => y => {
    const $0 = genericSelectionStatus.from(x);
    const $1 = genericSelectionStatus.from(y);
    if ($0.tag === "Inl") { return $1.tag === "Inl"; }
    if ($0.tag === "Inr") {
      if ($1.tag === "Inr") {
        if ($0._1.tag === "Inl") { return $1._1.tag === "Inl"; }
        if ($0._1.tag === "Inr") {
          if ($1._1.tag === "Inr") {
            if ($0._1._1.tag === "Inl") {
              if ($1._1._1.tag === "Inl") { return $0._1._1._1 === $1._1._1._1; }
              return false;
            }
            if ($0._1._1.tag === "Inr") { return $1._1._1.tag === "Inr"; }
            return false;
          }
          return false;
        }
        return false;
      }
      return false;
    }
    return false;
  }
};
const eqPromotionalItemTarget = dictEq => (
  {
    eq: (() => {
      const $0 = {eq: x => y => dictEq.eq(x.product)(y.product) && x.productSeq === y.productSeq};
      return x => y => {
        if (x.tag === "TargetCart") {
          if (y.tag === "TargetCart") { return true; }
          if (y.tag === "TargetProductItems") { return false; }
          $runtime.fail();
        }
        if (x.tag === "TargetProductItems") {
          if (y.tag === "TargetCart") { return false; }
          if (y.tag === "TargetProductItems") { return Data$dMap$dInternal.eqMap($0)(Data$dEq.eqUnit).eq(x._1)(y._1); }
          $runtime.fail();
        }
        if (y.tag === "TargetCart") { $runtime.fail(); }
        if (y.tag === "TargetProductItems") { $runtime.fail(); }
        $runtime.fail();
      };
    })()
  }
);
const eqPromotionalItemSource = dictEq => (
  {
    eq: (() => {
      const $0 = Data$dEq.eqArrayImpl(x => y => dictEq.eq(x.product)(y.product) && x.productSeq === y.productSeq);
      return x => y => {
        if (x.tag === "NoSource") {
          if (y.tag === "NoSource") { return true; }
          if (y.tag === "SourceProductItems") { return false; }
          $runtime.fail();
        }
        if (x.tag === "SourceProductItems") {
          if (y.tag === "NoSource") { return false; }
          if (y.tag === "SourceProductItems") { return $0(x._1)(y._1); }
          $runtime.fail();
        }
        if (y.tag === "NoSource") { $runtime.fail(); }
        if (y.tag === "SourceProductItems") { $runtime.fail(); }
        $runtime.fail();
      };
    })()
  }
);
const eqPromotionalItemAssignment = dictEq => (
  {
    eq: x => y => {
      const $0 = genericPromotionalItemAssignment.from(x);
      const $1 = genericPromotionalItemAssignment.from(y);
      if ($0.tag === "Inl") { return $1.tag === "Inl"; }
      if ($0.tag === "Inr") {
        if ($1.tag === "Inr") {
          if ($0._1.tag === "Inl") { return $1._1.tag === "Inl"; }
          if ($0._1.tag === "Inr") {
            if ($1._1.tag === "Inr") {
              if ($0._1._1.tag === "Inl") {
                if ($1._1._1.tag === "Inl") { return dictEq.eq($0._1._1._1.product)($1._1._1._1.product) && $0._1._1._1.productSeq === $1._1._1._1.productSeq; }
                return false;
              }
              if ($0._1._1.tag === "Inr") { return $1._1._1.tag === "Inr"; }
              return false;
            }
            return false;
          }
          return false;
        }
        return false;
      }
      return false;
    }
  }
);
const eqPromotionalItem = dictEq => (
  {
    eq: (() => {
      const $0 = eqPromotionalItemTarget(dictEq);
      const $1 = eqPromotionalItemSource(dictEq);
      const $2 = eqPromotionalItemAssignment(dictEq);
      return x => y => x.active === y.active && $2.eq(x.assignment)(y.assignment) && (() => {
        if (x.input.tag === "FreeProductInput") {
          if (y.input.tag === "FreeProductInput") { return x.input._1.selection === y.input._1.selection; }
          return false;
        }
        if (x.input.tag === "NoInput") { return y.input.tag === "NoInput"; }
        return false;
      })() && Restaumatic$dPromotionsEngine$dPromotions$dPromotion.eqPromotion.eq(x.promotion)(y.promotion) && x.promotionalItemId === y.promotionalItemId && eqSelectionStatus.eq(x.selection)(y.selection) && $1.eq(x.source)(y.source) && $0.eq(x.target)(y.target) && (() => {
        if (x.value.tag === "Nothing") { return y.value.tag === "Nothing"; }
        if (x.value.tag === "Just") {
          if (y.value.tag === "Just") { return x.value._1 === y.value._1; }
          return false;
        }
        return false;
      })();
    })()
  }
);
const ordPromotionalItem = dictEq => (
  {
    compare: a => b => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidOrdering)(x => x)([
      Restaumatic$dPromotionsEngine$dPromotions$dPromotion.ordPromotion.compare(a.promotion)(b.promotion),
      Data$dOrd.ordInt.compare(a.promotionalItemId)(b.promotionalItemId)
    ]),
    Eq0: () => eqPromotionalItem(dictEq)
  }
);
const encodeSelectionStatus = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericSelectionStatus)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AutoEnabled"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AutoDisabled"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "UserEnabled"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "UserDisabled"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              return $3.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodePromotionalItemSource = dictEncode => (
  {
    encode: Foreign$dEncoding.defaultEncode(genericPromotionalItemSource)((() => {
      const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "NoSource"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
      const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "SourceProductItems"})((() => {
        const $1 = Data$dFunctor.arrayMap(dictEncode.encode);
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $1(v)), Data$dList$dTypes.Nil)};
      })());
      return {
        encodeOpts: opts => v => {
          if (v.tag === "Inl") {
            return $0.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1);
          }
          if (v.tag === "Inr") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1);
          }
          $runtime.fail();
        }
      };
    })())
  }
);
const encodePromotionalItemAssignment = dictEncode => (
  {
    encode: Foreign$dEncoding.defaultEncode(genericPromotionalItemAssignment)((() => {
      const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AssignmentToCart"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
      const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "UnassignmentToCart"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
      const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AssignmentToProduct"})({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", dictEncode.encode(v)), Data$dList$dTypes.Nil)
      });
      const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "UnassignmentToProduct"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
      return {
        encodeOpts: opts => v => {
          if (v.tag === "Inl") {
            return $0.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1);
          }
          if (v.tag === "Inr") {
            if (v._1.tag === "Inl") {
              return $1.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1);
            }
            if (v._1.tag === "Inr") {
              if (v._1._1.tag === "Inl") {
                return $2.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1);
              }
              if (v._1._1.tag === "Inr") {
                return $3.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1);
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
      };
    })())
  }
);
const defaultInput = promo => {
  if (promo.prize.tag === "Freeby") {
    return Restaumatic$dPromotions$dTypes$dPromotionalItem.$PromotionalItemInput(
      "FreeProductInput",
      {
        selection: (() => {
          const $0 = Restaumatic$dPromotionsEngine$dPromotions$dPromotion.getFirstPromotionFreebyName(promo);
          if ($0.tag === "Nothing") { return ""; }
          if ($0.tag === "Just") { return $0._1; }
          $runtime.fail();
        })()
      }
    );
  }
  if (promo.prize.tag === "PercentageDiscount") { return Restaumatic$dPromotions$dTypes$dPromotionalItem.NoInput; }
  if (promo.prize.tag === "PriceDiscount") { return Restaumatic$dPromotions$dTypes$dPromotionalItem.NoInput; }
  if (promo.prize.tag === "CouponValue") { return Restaumatic$dPromotions$dTypes$dPromotionalItem.NoInput; }
  if (promo.prize.tag === "TextInformation") { return Restaumatic$dPromotions$dTypes$dPromotionalItem.NoInput; }
  $runtime.fail();
};
const mkDefaultPromotionalItem = promoItemId => promo => assignmentMode => {
  const $0 = (() => {
    if (assignmentMode.tag === "AutoAssign") { return true; }
    if (assignmentMode.tag === "ManualAssign") { return false; }
    $runtime.fail();
  })()
    ? AutoDisabled
    : UserDisabled;
  const $1 = defaultInput(promo);
  const $2 = (() => {
    if (promo.conditions.tag === "CartPromotion") { return UnassignmentToCart; }
    if (promo.conditions.tag === "ProductPromotion") { return UnassignmentToProduct; }
    $runtime.fail();
  })();
  return initTarget => initSource => (
    {promotionalItemId: promoItemId, promotion: promo, target: initTarget, source: initSource, assignment: $2, selection: $0, input: $1, value: Data$dMaybe.Nothing, active: true}
  );
};
const decodeSelectionStatus = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericSelectionStatus)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "AutoEnabled"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "AutoDisabled"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "UserEnabled"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "UserDisabled"})(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))
};
const decodePromotionalItemSource = dictDecode => (
  {
    decode: Foreign$dEncoding.defaultDecode(genericPromotionalItemSource)(Foreign$dGeneric$dClass.genericDecodeSum(Foreign$dGeneric$dClass.genericDecodeConstructor({
      reflectSymbol: () => "NoSource"
    })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(Foreign$dGeneric$dClass.genericDecodeConstructor({
      reflectSymbol: () => "SourceProductItems"
    })((() => {
      const $0 = Foreign$dGeneric$dClass.arrayDecode(dictDecode);
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })())(Foreign$dGeneric$dClass.genericCountArgsArgument)))
  }
);
const decodePromotionalItemAssignment = dictDecode => (
  {
    decode: Foreign$dEncoding.defaultDecode(genericPromotionalItemAssignment)(Foreign$dGeneric$dClass.genericDecodeSum(Foreign$dGeneric$dClass.genericDecodeConstructor({
      reflectSymbol: () => "AssignmentToCart"
    })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(Foreign$dGeneric$dClass.genericDecodeSum(Foreign$dGeneric$dClass.genericDecodeConstructor({
      reflectSymbol: () => "UnassignmentToCart"
    })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(Foreign$dGeneric$dClass.genericDecodeSum(Foreign$dGeneric$dClass.genericDecodeConstructor({
      reflectSymbol: () => "AssignmentToProduct"
    })({decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => dictDecode.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(Foreign$dGeneric$dClass.genericDecodeConstructor({
      reflectSymbol: () => "UnassignmentToProduct"
    })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))
  }
);
const combineableClique = promotionalItems => {
  const promotionsClique = Restaumatic$dPromotionsEngine$dPromotions$dPromotion.combineableClique(Data$dFunctor.arrayMap(promotion)(promotionalItems));
  return Data$dArray.filter(item => Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v => v1 => v || v1})})(Restaumatic$dPromotionsEngine$dPromotions$dPromotion.eqPromotion.eq(item.promotion))(promotionsClique))(promotionalItems);
};
const changeInput = dictEq => promotionalItem => newInput => {
  if (newInput.tag === "FreeProductInput") {
    if (Restaumatic$dPromotionsEngine$dPromotions$dPromotion.isInPromotionFreebies(newInput._1.selection)(promotionalItem.promotion)) {
      return {...promotionalItem, input: Restaumatic$dPromotions$dTypes$dPromotionalItem.$PromotionalItemInput("FreeProductInput", {selection: newInput._1.selection})};
    }
    return promotionalItem;
  }
  if (newInput.tag === "NoInput") { return {...promotionalItem, input: Restaumatic$dPromotions$dTypes$dPromotionalItem.NoInput}; }
  $runtime.fail();
};
const canCombineWithAllOthers = promotionalItem => promotionalItems => Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWithAllOthers(promotionalItem.promotion)(Data$dFunctor.arrayMap(promotion)(promotionalItems));
const canCombineWithAll = promotionalItem => promotionalItems => Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWithAll(promotionalItem.promotion)(Data$dFunctor.arrayMap(promotion)(promotionalItems));
const partitionCombineable = promotionalItems => {
  const $0 = Data$dArray.partition(isEnabled)(promotionalItems);
  const $1 = $0.yes;
  const $2 = Data$dArray.partition(v2 => Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWithAll(v2.promotion)(Data$dFunctor.arrayMap(promotion)($1)))($0.no);
  return Data$dTuple.$Tuple(Data$dSemigroup.concatArray($1)($2.yes), $2.no);
};
const canCombineWith = otherPromotionalItem => promotionalItem => Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWith(otherPromotionalItem.promotion)(promotionalItem.promotion);
const assignmentProductItemKey = assign => {
  if (assign.tag === "AssignmentToProduct") { return Data$dMaybe.$Maybe("Just", assign._1); }
  return Data$dMaybe.Nothing;
};
const assignment = x => x.assignment;
const resetPromotionalItem = dictOrd => item => {
  const disabledItem = item.selection.tag === "UserEnabled" || item.selection.tag === "UserDisabled" ? {...item, selection: UserDisabled} : {...item, selection: AutoDisabled};
  if (disabledItem.assignment.tag === "AssignmentToCart") { return setAssignment(dictOrd)(UnassignmentToCart)(disabledItem); }
  if (disabledItem.assignment.tag === "AssignmentToProduct") { return setAssignment(dictOrd)(UnassignmentToProduct)(disabledItem); }
  return disabledItem;
};
const resetPromotionalItems = dictOrd => Data$dFunctor.arrayMap(resetPromotionalItem(dictOrd));
const assignedProductItemKey = x => {
  if (x.assignment.tag === "AssignmentToProduct") { return Data$dMaybe.$Maybe("Just", x.assignment._1); }
  return Data$dMaybe.Nothing;
};
const allocatedProductItemKeys = item => {
  if (item.assignment.tag === "AssignmentToProduct") {
    return Data$dSemigroup.concatArray([item.assignment._1])((() => {
      if (item.source.tag === "NoSource") { return []; }
      if (item.source.tag === "SourceProductItems") { return item.source._1; }
      $runtime.fail();
    })());
  }
  return [];
};
const allCombineable = promotionalItem => Data$dArray.filter(canCombineWith(promotionalItem));
export {
  $PromotionalItemAssignment,
  $PromotionalItemSource,
  $PromotionalItemTarget,
  $SelectionStatus,
  AssignmentToCart,
  AssignmentToProduct,
  AutoDisabled,
  AutoEnabled,
  NoSource,
  PromotionalItem,
  SourceProductItems,
  TargetCart,
  TargetProductItems,
  UnassignmentToCart,
  UnassignmentToProduct,
  UserDisabled,
  UserEnabled,
  allCombineable,
  allocatedProductItemKeys,
  assignedProductItemKey,
  assignment,
  assignmentProductItemKey,
  canCombineWith,
  canCombineWithAll,
  canCombineWithAllOthers,
  changeInput,
  combineableClique,
  decodePromotionalItemAssignment,
  decodePromotionalItemSource,
  decodeSelectionStatus,
  defaultInput,
  encodePromotionalItemAssignment,
  encodePromotionalItemSource,
  encodeSelectionStatus,
  eqPromotionalItem,
  eqPromotionalItemAssignment,
  eqPromotionalItemSource,
  eqPromotionalItemTarget,
  eqSelectionStatus,
  excludeItemsFrom,
  forceSetAssignment,
  functorPromotionalItemAssignment,
  functorPromotionalItemSource,
  genericPromotionalItem,
  genericPromotionalItemAssignment,
  genericPromotionalItemSource,
  genericPromotionalItemTarget,
  genericSelectionStatus,
  hasRequiredInput,
  input,
  isActive,
  isAutoAssignablePromotionalItem,
  isCartPromotionalItem,
  isEnabled,
  isEnabledByUser,
  isEnabledSelection,
  isItemAutoAssigneable,
  isProductPromotionalItem,
  isTouchedByUser,
  isUserDisabledSelection,
  isUserEnabledSelection,
  isUserSelection,
  mkAssignmentToCart,
  mkAssignmentToProduct,
  mkAutoDisabled,
  mkAutoEnabled,
  mkDefaultAssignment,
  mkDefaultPromotionalItem,
  mkFreeProductInput,
  mkNoInput,
  mkNoSource,
  mkPromotionalItem,
  mkSourceItems,
  mkTargetCart,
  mkTargetItems,
  mkUnassignmentToCart,
  mkUnassignmentToProduct,
  mkUserDisabled,
  mkUserEnabled,
  mkUserEnabledDefault,
  newtypePromotionalItem,
  oldenUserEnabledSelectionStatus,
  oldenUserSelection,
  ordPromotionalItem,
  partitionCombineable,
  productItemKeysInTarget,
  promotion,
  promotionId,
  promotionalItemId,
  promotionalItemInput,
  promotionalItemValue,
  promotions,
  resetPromotionalItem,
  resetPromotionalItems,
  selectFreeby,
  selectedFreeby,
  selection,
  selectionAge,
  selectionStatusAge,
  setActive,
  setAssignment,
  setInputFreeby,
  setNoInput,
  setSelection,
  setValue,
  showPromotionalItem,
  showPromotionalItemAssignment,
  showPromotionalItemSource,
  showPromotionalItemTarget,
  showSelectionStatus,
  source,
  sourceProductItems,
  target,
  targetContains,
  targetProductItemKeys,
  unassign,
  value
};
